module.exports = __webpack_public_path__ + "fonts/adellesans-regular-webfont.3c080b47.woff2";